var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8Libya(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "48px",
    height: "48px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#4caf50",
    d: "M41.843,33H6.157C9.453,39.52,16.196,44,24,44S38.547,39.52,41.843,33z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#424242",
    d: "M44,24c0-3.241-0.788-6.292-2.157-9H6.157C4.788,17.708,4,20.759,4,24s0.788,6.292,2.157,9h35.686 C43.212,30.292,44,27.241,44,24z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#d50000",
    d: "M24,4C16.195,4,9.453,8.48,6.157,15h35.686C38.547,8.48,31.805,4,24,4z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M23.5,28.52c-2.484,0-4.5-2.012-4.5-4.5c0-2.484,2.016-4.5,4.5-4.5c0.285,0,0.566,0.035,0.836,0.086 C23.637,19.23,22.848,19,22,19c-2.762,0-5,2.238-5,5s2.238,5,5,5c0.813,0,1.566-0.211,2.242-0.555 C24,28.488,23.754,28.52,23.5,28.52z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M24.094,24l7.609-2.473L27,28v-8l4.703,6.473L24.094,24z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Libya);
export default __webpack_public_path__ + "static/media/icons8-libya.d1182157a7edfdbaa935fa2d7bee88e5.svg";
export { ForwardRef as ReactComponent };